// src/pages/docs/DocsLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import { projectMenus } from "../../components/layout/ProjectMenus";

export default function DocsLayout() {
  const { title, base, sections } = projectMenus.docs;

  return (
    <SidebarLayout title={title} base={base} sections={sections}>
      <div className="p-6 pb-10 max-w-screen-2xl mx-auto">
        <Outlet />
      </div>
    </SidebarLayout>
  );
}
